/**
 * Single source of truth for cost types on the frontend.
 *
 * Add a new type HERE (and to the `costType` enum in backend/models/Cost.js)
 * and every form, filter and chart picks it up. The list used to be copied
 * into six files, which is how "Rovinieta" went missing from the Add Cost
 * form while the documents side already knew about it.
 */
export const COST_TYPES = ['Fuel', 'RCA', 'Casco', 'ITP', 'Rovinieta', 'Road Assistance', 'Maintenance', 'Leasing', 'Repair', 'Tax', 'Other'];

export const COST_TYPE_COLORS = {
  Fuel: '#f59e0b', RCA: '#3b82f6', Casco: '#8b5cf6', ITP: '#14b8a6', Rovinieta: '#ec4899', 'Road Assistance': '#84cc16',
  Maintenance: '#10b981', Leasing: '#0ea5e9', Repair: '#ef4444',
  Tax: '#6b7280', Other: '#9ca3af',
};

const BY_LOWER = Object.fromEntries(Object.entries(COST_TYPE_COLORS).map(([k, v]) => [k.toLowerCase(), v]));

/** Colour for a cost type, case-insensitive; unknown/legacy types get the "Other" colour. */
export const costTypeColor = (type) => BY_LOWER[String(type || '').toLowerCase()] || COST_TYPE_COLORS.Other;
